import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DemoComponent } from './demo/demo.component';
import { DynamicFormComponent } from './dynamic-form/dynamic-form.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { LoginComponent } from './sign-in/login/login.component';
import { ResetPasswordEmailComponent } from './sign-in/reset-password/reset-password-email.component';
import { ResetPasswordEmailSentComponent } from './sign-in/reset-password-completed/reset-password-email-sent.component';
import { ResetPasswordContactComponent } from './sign-in/reset-password-get-help/reset-password-contact.component';
import { DynamicFormDataEntryComponent } from './dynamic-form-data-entry/dynamic-form-data-entry.component';
import { DynamicGridComponent } from './dynamic-grid/dynamic-grid.component';
import { GetDataComponent } from './helpers/get-data/get-data.component';
import { DynamicViewComponent } from './dynamic-view/dynamic-view.component';
import { DynamicEditComponent } from './dynamic-edit/dynamic-edit.component';

import { PaymentComponent } from './payment/payment.component';
import { PaymentChoosePlanComponent } from './payment/payment-choose-plan/payment-choose-plan.component';
import { PaymentMonthlySubscriptionComponent } from './payment/payment-monthly-subscription/payment-monthly-subscription.component';
import { RequestAccessReadStepsComponent } from './request-access/request-access-read-steps.component';
import { HelpAndGuidesComponent } from './help-and-guides/help-and-guides.component';
import { FriendInvitationComponent } from './friend-invitation/friend-invitation.component';
import { DashboardComponent } from './my-dashboard/dashboard.component';
import { MyDelegatesComponent } from './my-delegates/my-delegates.component';
import { SharedPlansComponent } from './shared-plans/shared-plans.component';
import { DialogComponent } from './dialog/dialog.component';
import { NotificationCentreComponent } from './notification-centre/notification-centre.component';
import { DynamicSonListComponent } from './dynamic-son-list/dynamic-son-list.component';
import { DynamicSonListTwoColumnsComponent } from './dynamic-son-list-two-columns/dynamic-son-list-two-columns.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { SignUpReferralCodeComponent } from './sign-up/sign-up-referral-code/sign-up-referral-code.component';
import { SignUpPasswordComponent } from './sign-up/sign-up-password/sign-up-password.component';
import { SignUpCompletedComponent } from './sign-up/sign-up-completed/sign-up-completed.component';
import { AboutMeComponent } from './about-me/about-me.component';
import { Step1Component } from './about-me/step1/step1.component';
import { Step2Component } from './about-me/step2/step2.component';
import { Step3Component } from './about-me/step3/step3.component';
import { MultiFactorAuthentificationComponent } from './multi-factor-authentification/multi-factor-authentification.component';
import { Mfa1Component } from './multi-factor-authentification/mfa1/mfa1.component';
import { Mfa2Component } from './multi-factor-authentification/mfa2/mfa2.component';
import { Mfa3Component } from './multi-factor-authentification/mfa3/mfa3.component';
import { ManagePeopleListComponent } from './manage-people-list/manage-people-list.component';
import { PersonRowComponent } from './manage-people-list/person-row/person-row.component';
import { TestPageComponent } from './test-page/test-page.component';
import { MultiFactorAuthentificationNewDeviceComponent } from './multi-factor-authentification-new-device/multi-factor-authentification-new-device.component';
import { MfaNewDevice1Component } from './multi-factor-authentification-new-device/mfa-new-device1/mfa-new-device1.component';
import { MfaNewDevice2Component } from './multi-factor-authentification-new-device/mfa-new-device2/mfa-new-device2.component';
import { DelegateHomePageComponent } from './delegate-home-page/delegate-home-page.component';
import { DelegateCreatePlan1Component } from './delegate-home-page/delegate-create-plan-step1/delegate-create-plan1.component';
import { DelegateCreatePlan2Component } from './delegate-home-page/delegate-create-plan-step2/delegate-create-plan2.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
/////////////////////yaacov////////////////////
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { AdminDashboardTab1Component } from './admin-dashboard/admin-dashboard-tab1/admin-dashboard-tab1.component';
import { AdminDashboardTab2Component } from './admin-dashboard/admin-dashboard-tab2/admin-dashboard-tab2.component';
import { AdminDashboardTab3Component } from './admin-dashboard/admin-dashboard-tab3/admin-dashboard-tab3.component';
import { AdminDashboardTab4Component } from './admin-dashboard/admin-dashboard-tab4/admin-dashboard-tab4.component';
import { AdminDashboardTab5Component } from './admin-dashboard/admin-dashboard-tab5/admin-dashboard-tab5.component';
import { AdminDashboardTab6Component } from './admin-dashboard/admin-dashboard-tab6/admin-dashboard-tab6.component';
import { MyDashboardTab1Component } from './my-dashboard/my-dashboard-tab1/my-dashboard-tab1.component';
import { MyDashboardTab2Component } from './my-dashboard/my-dashboard-tab2/my-dashboard-tab2.component';
import { MyDashboardTab3Component } from './my-dashboard/my-dashboard-tab3/my-dashboard-tab3.component';
import { MyDashboardTab4Component } from './my-dashboard/my-dashboard-tab4/my-dashboard-tab4.component';
import { MyAccountTab1Component } from './my-account/my-account-tab1/my-account-tab1.component';
import { MyAccountTab2Component } from './my-account/my-account-tab2/my-account-tab2.component';
import { MyAccountTab3Component } from './my-account/my-account-tab3/my-account-tab3.component';
import { MyAccountTab4Component } from './my-account/my-account-tab4/my-account-tab4.component';
import { MyAccountTab5Component } from './my-account/my-account-tab5/my-account-tab5.component';
import { SummariesComponent } from './summaries/summaries.component';
import { PlanSummariesComponent } from './summaries/plan-summaries/plan-summaries.component';
import { AssetsSummaryComponent } from './summaries/assets-summary/assets-summary.component';
import { DebtSummaryComponent } from './summaries/debt-summary/debt-summary.component';
import { IncomeSummaryComponent } from './summaries/income-summary/income-summary.component';
import { ExpenseSummaryComponent } from './summaries/expense-summary/expense-summary.component';
import { PropertySummaryComponent } from './summaries/property-summary/property-summary.component';
import { DynamicSonListThreeColumnsComponent } from './dynamic-son-list-three-columns/dynamic-son-list-three-columns.component';
import { DynamicSonListFourColumnsComponent } from './dynamic-son-list-four-columns/dynamic-son-list-four-columns.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { DynamicSonMultiSelectComponent } from './dynamic-son-multi-select/dynamic-son-multi-select.component';
import {NgxMaskModule, IConfig} from 'ngx-mask';
import { DelegateInvitationSentComponent } from './my-delegates/delegate_invitation_sent/delegate-invitation-sent.component';

/////////////////////yaacov////////////////////
export const options: Partial<IConfig> | (() => Partial<IConfig>)={};

@NgModule({
  declarations: [
    AppComponent,
    DemoComponent,
    DynamicFormComponent,
    SignInComponent,
    LoginComponent,
    ResetPasswordEmailComponent,
    ResetPasswordEmailSentComponent,
    ResetPasswordContactComponent,
    DynamicFormDataEntryComponent,
    DynamicGridComponent,
    GetDataComponent,
    DynamicViewComponent,
    DynamicEditComponent,
    PaymentComponent,
    PaymentChoosePlanComponent,
    PaymentMonthlySubscriptionComponent,
    RequestAccessReadStepsComponent,
    HelpAndGuidesComponent,
    FriendInvitationComponent,
    DashboardComponent,
    MyDelegatesComponent,
    SharedPlansComponent,
    DynamicSonListComponent,
    NotificationCentreComponent,
    ////////Yaacov/////////
    DialogComponent,
    DynamicSonListTwoColumnsComponent,
    SignUpComponent,
    SignUpReferralCodeComponent,
    SignUpPasswordComponent,
    SignUpCompletedComponent,
    AboutMeComponent,
    Step1Component,
    Step2Component,
    Step3Component,
    MultiFactorAuthentificationComponent,
    Mfa1Component,
    Mfa2Component,
    Mfa3Component,
    ManagePeopleListComponent,
    PersonRowComponent,
    TestPageComponent,
    MultiFactorAuthentificationNewDeviceComponent,
    MfaNewDevice1Component,
    MfaNewDevice2Component,
    DelegateHomePageComponent,
    DelegateCreatePlan1Component,
    DelegateCreatePlan2Component,
    MyAccountComponent,
    AdminDashboardComponent,
    AdminDashboardTab1Component,
    AdminDashboardTab2Component,
    AdminDashboardTab3Component,
    AdminDashboardTab4Component,
    AdminDashboardTab5Component,
    AdminDashboardTab6Component,
    MyDashboardTab1Component,
    MyDashboardTab2Component,
    MyDashboardTab3Component,
    MyDashboardTab4Component,
    MyAccountTab1Component,
    MyAccountTab2Component,
    MyAccountTab3Component,
    MyAccountTab4Component,
    MyAccountTab5Component,
    SummariesComponent,
    PlanSummariesComponent,
    AssetsSummaryComponent,
    DebtSummaryComponent,
    IncomeSummaryComponent,
    ExpenseSummaryComponent,
    PropertySummaryComponent,
    DynamicSonListThreeColumnsComponent,
    DynamicSonListFourColumnsComponent,
    DynamicSonMultiSelectComponent,
    DelegateInvitationSentComponent,
    ////////Yaacov/////////
    ////////Jeremie////////

    ////////Jeremie////////
  ],
  imports: [

    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    NgbModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgxMaskModule.forRoot(options)


  ],

  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
